import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { useUIStore } from '../stores/useUIStore' // Need this for mobile overlay
import Sidebar from '../components/Sidebar/Sidebar'

const RootLayout = () => {
  const isSidebarOpen = useUIStore(state => state.isSidebarOpen)
  const setIsSidebarOpen = useUIStore(state => state.setIsSidebarOpen)

  return (
    <Box className="app-root">
      {isSidebarOpen && (
        <Box
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 998,
            display: { md: 'none' },
          }}
        />
      )}

      <Sidebar />

      <Suspense fallback={<div className="app-loading-fullscreen">Loading...</div>}>
        <Outlet />
      </Suspense>
    </Box>
  )
}

export default RootLayout
